export default [
  {
    path: "/evaluation/procurements",
    name: "evaluation-procurements",
    meta: {
      title: "Evaluation Procurements",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/EvaluationProcurements.vue"),
  },
  {
    path: "/evaluation/committees",
    name: "evaluation-committees",
    meta: {
      title: "Evaluation Committees",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/EvaluationCommittees.vue"),
  },
  {
    path: "/evaluation/approvals",
    name: "evaluation-approvals",
    meta: {
      title: "Evaluation Approvals",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/EvaluationApprovals.vue"),
  },
  {
    path: "/evaluation/member",
    name: "evaluation-member",
    meta: {
      title: "Evaluation Member",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/EvaluationMyCommittees.vue"),
  },
  {
    path: '/evaluation/approve',
    name: 'approve-committee',
    meta: {
      title: "Approve Committee",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/ApproveCommittee.vue"),
  },
  {
    path: '/evaluation/committee/:id/:desk?',
    name: 'manage-committee',
    meta: {
      title: "Manage Committee",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/ManageCommittee.vue"),
  },
  {
    path: "/evaluation/tenders",
    name: "evaluation-tenders",
    meta: {
      title: "Evaluation Tenders",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/tenders"),
  },

  {
    path: '/evaluation/cancel/:id',
    name: 'cancel-process',
    meta: {
      title: "Cancel Procurement Process",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/CancelProcess.vue"),
  },
  {
    path: '/evaluation/post-qualification/:id',
    name: 'post-qualification',
    meta: {
      title: "Post-Qualification",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/PostQualification.vue"),
  },
  {
    path: '/market-price-analysis/:id',
    name: 'market-price-analysis',
    meta: {
      title: "Price Analysis",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/MarketPriceAnalysis.vue"),
  },
  {
    path: '/evaluation/notify-best-bidder/:id',
    name: 'notify-best-bidder',
    meta: {
      title: "Notify Best Evaluated Bidder",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/NotifyBestBidder.vue"),
  },
  {
    path: '/evaluation/invitation/:id',
    name: 'evaluator-invitation',
    meta: {
      title: "Evaluator Invitation",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/EvaluatorInvitation.vue"),
  },
  {
    path: '/evaluation/bid-details/:id',
    name: 'view-bid-details',
    meta: {
      title: "View Bid Details",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/ViewBidDetails.vue"),
  },
  {
    path: '/evaluation/corrections/:id',
    name: 'request-corrections',
    meta: {
      title: "Request Corrections",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/RequestCorrections.vue"),
  },
  {
    path: '/evaluation/approve/:id',
    name: 'approve-evaluation',
    meta: {
      title: "Approve Evaluation Results",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/ApproveEvaluation.vue"),
  },
  {
    path: '/evaluation/intention/:id',
    name: 'notify-intention-to-award',
    meta: {
      title: "Notify Intention to Award",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/NotifyIntentionToAward.vue"),
  },
  {
    path: '/evaluation/clarification/:id',
    name: 'request-clarification',
    meta: {
      title: "Request Clarification",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/RequestClarification.vue"),
  },
  {
    path: '/evaluation/notify-unsuccessful/:id',
    name: 'notify-unsuccessful-bidders',
    meta: {
      title: "Notify Unsuccessful Bidders",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/NotifyUnsuccessfulBidders.vue"),
  },

    //EVALUATION NEW ROUTES
  {
    path: '/evaluation/bids/:id',
    name: 'new-bid-evaluation',
    meta: {
      title: "Bid Evaluation",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/NewBidEvaluationWorkspace.vue"),
  },

  {
    path: '/evaluation/shortlist/:id',
    name: 'short-listed-bidders',
    meta: {
      title: "Shortlisted Suppliers",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/short-listed-bidders-approval.vue"),
  },

  {
    path: '/evaluation/shortlist',
    name: 'short-listed-bidders-review',
    meta: {
      title: "Shortlisted Suppliers",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/short-listed-bidders-approval.vue"),
  },

  {
    path: '/evaluation/technical-shortlist/:id',
    name: 'technical-section-shortlisted',
    meta: {
      title: "Technical Shortlist",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/technical-section-shortlisted-approval.vue"),
  },

  {
    path: '/evaluation/technical-shortlist',
    name: 'technical-section-shortlisted-review',
    meta: {
      title: "Technical Shortlist",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/technical-section-shortlisted-approval.vue"),
  },

  {
    path: '/evaluation/evaluation-report',
    name: 'evaluation-report-review',
    meta: {
      title: "Evaluation Report",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/EvaluationReport.vue"),
  },

  {
    path: '/evaluation/evaluation-report/:id',
    name: 'evaluation-report',
    meta: {
      title: "Evaluation Report",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/EvaluationReport.vue"),
  },

  {
    path: '/evaluation/award-recommendations',
    name: 'award-recommendations',
    meta: {
      title: "Evaluation Award Recommendations",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/award-recommendation-approvals.vue"),
  },
  {
    path: '/evaluation/bid/:id',
    name: 'bid-evaluation',
    meta: {
      title: "Bid Evaluation",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/BidEvaluation.vue"),
  },
  {
    path: '/evaluation/report/:id',
    name: 'submit-report',
    meta: {
      title: "Submit Evaluation Report",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/SubmitReport.vue"),
  },

  {
    path: '/evaluation/review-award-recommendation/:id',
    name: 'review-award-recommendation',
    meta: {
      title: "Review Award Recommendation",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/review-award-recommendation.vue"),
  },

  {
    path: '/evaluation/stand-still',
    name: 'evaluation-stand-stills',
    meta: {
      title: "Evaluation Stand Stills",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/evaluation-stand-stills.vue"),
  },
  {
    path: '/evaluation/manage-stand-still/:id',
    name: 'manage-stand-still',
    meta: {
      title: "Evaluation Stand Still",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/ManageStandstill.vue"),
  },
  {
    path: '/evaluation/pending-funds-confirmation',
    name: 'awards-pending-funds-confirmation',
    meta: {
      title: "Pending Funds Confirmation",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/pending-funds-confirmations.vue"),
  },
  {
    path: '/evaluation/confirm-procurement-funds/:id',
    name: 'confirm-procurement-funds',
    meta: {
      title: "Confirm Procurement Funds",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/ConfirmFunds.vue"),
  },  {
    path: '/evaluation/pending-contract-awards',
    name: 'pending-contract-awards',
    meta: {
      title: "Pending Contract Awards",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/pending-contract-awards.vue"),
  },
  {
    path: '/evaluation/submitted-draft-contracts',
    name: 'submitted-draft-contracts',
    meta: {
      title: "Submitted Draft Contracts",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/submitted-draft-contracts.vue"),
  },
  {
    path: '/evaluation/approved-draft-contracts',
    name: 'approved-draft-contracts',
    meta: {
      title: "Approved Draft Contracts",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/approved-draft-contracts.vue"),
  },
  {
    path: '/evaluation/create-draft-contract/:id',
    name: 'create-draft-contract',
    meta: {
      title: "Create Draft Contract",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/CreateDraftContract.vue"),
  },

  {
    path: '/evaluation/review-draft-contract',
    name: 'review-draft-contract',
    meta: {
      title: "Review Draft Contract",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/ReviewDraftContract.vue"),
  },
  {
    path: '/evaluation/finalize-draft-contract/:id',
    name: 'finalize-draft-contract',
    meta: {
      title: "Finalize Draft Contract",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/ReviewDraftContract.vue"),
  },
  {
    path: '/evaluation/pending-contract-clearance',
    name: 'pending-contract-clearance',
    meta: {
      title: "Pending Contract Clearance",
      authRequired: true,
      privileges: [],
    },
    component: () => import("../views/evaluation/evaluation-marking/contracts-pending-legal-clearance.vue"),
  },
]
